import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import CustomerButton from "../../customer-button/CustomerButton";
const useStyles = makeStyles({
  npsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 24
  },
  clientReviewTitle: {
    marginLeft: 24,
    marginRight: 24,
    textAlign: "center"
  },
  buttonContainer: {
    marginTop: 24,
    alignSelf: "center",
    display: "flex"
  }
});
export const nextButtonStyle = {
  width: 100,
  marginLeft: 10,
  marginRight: 10
};
const ResolutionScreen = ({
  onSubmitResoluation
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const [disableButton, setDisableButton] = React.useState(false);
  const handleButtonClick = result => {
    setDisableButton(true);
    onSubmitResoluation(result);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.npsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.clientReviewTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, t("Did we fully resolve your issue?"))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    id: "resolvedYes",
    style: nextButtonStyle,
    onClick: () => handleButtonClick(true),
    disabled: disableButton
  }, "Yes"), /*#__PURE__*/React.createElement(CustomerButton, {
    id: "resolvedNo",
    style: nextButtonStyle,
    onClick: () => handleButtonClick(false),
    disabled: disableButton
  }, "No")));
};
ResolutionScreen.propTypes = {
  message: PropTypes.object.isRequired,
  onSubmitResoluation: PropTypes.func.isRequired
};
export default ResolutionScreen;